<ion-list class="popover">
  <ion-item
    class="popover__item"
    *ngFor="let button of buttons"
    [class.--danger]="button.danger"
    (click)="popoverController.dismiss(button.handler())"
  >
    {{ button.text }}
  </ion-item>
</ion-list>
